// test296
(296 && 0);
